//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  WritableSignal,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

//local imports
import { RoomContentModel } from "@app/catalog";
import { PresenterType } from "@app/shared";

@PresenterType({
  model: RoomContentModel,
  key: "tileBottom",
})

@Component({
  selector: 'room-content-carousel-item-bottom',
  standalone: false,
  templateUrl: './room-content-carousel-item-bottom.component.html',
  styleUrl: './room-content-carousel-item-bottom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoomContentCarouselItemBottomComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  public data: WritableSignal<RoomContentModel> = signal<RoomContentModel>(undefined);

  public navigateToDetailPage() {
    this.router.navigate(["/catalog/room-content", this.data().id], {
      queryParamsHandling: "merge",
    });
  }
}
